import type { TableTabResponse } from '../types';

const GROUP_TABLE_MOCK_DATA: TableTabResponse = {
  type: 'group_table',
  tableRows: null,
  groups: [
    {
      groupName: 'Test Group A',
      tableRows: [
        {
          no: 1,
          teamName: 'Test Team A1',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 2,
          draws: 1,
          losses: 0,
          points: 7,
          form: ['W', 'D', 'W'],
          qualification: 'Playoffs',
          color: 'green',
          inPlay: true,
          jersey: null,
          flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/aa.svg',
        },
        {
          no: 2,
          teamName: 'Test Team A2',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 2,
          draws: 0,
          losses: 1,
          points: 6,
          form: ['W', 'L', 'W'],
          qualification: 'Playoffs',
          color: 'green',
          inPlay: false,
          jersey: null,
          flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ab.svg',
        },
        {
          no: 3,
          teamName: 'Test Team A3',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 1,
          draws: 0,
          losses: 2,
          points: 3,
          form: ['L', 'W', 'L'],
          qualification: null,
          color: null,
          inPlay: false,
          jersey: null,
          flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ac.svg',
        },
        {
          no: 4,
          teamName: 'Test Team A4',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 0,
          draws: 1,
          losses: 2,
          points: 1,
          form: ['D', 'L', 'L'],
          qualification: null,
          color: null,
          inPlay: false,
          jersey: null,
          flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ad.svg',
        },
      ],
    },
    {
      groupName: 'Test Group B',
      tableRows: [
        {
          no: 1,
          teamName: 'Test Team B1',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 3,
          draws: 0,
          losses: 0,
          points: 9,
          form: ['W', 'W', 'W'],
          qualification: 'Playoffs',
          color: 'green',
          inPlay: false,
          jersey: null,
          flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/ba.svg',
        },
        {
          no: 2,
          teamName: 'Test Team B2',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 1,
          draws: 1,
          losses: 1,
          points: 4,
          form: ['W', 'D', 'L'],
          qualification: null,
          color: null,
          inPlay: false,
          jersey: null,
          flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/bb.svg',
        },
        {
          no: 3,
          teamName: 'Test Team B3',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 1,
          draws: 0,
          losses: 2,
          points: 3,
          form: ['L', 'W', 'L'],
          qualification: null,
          color: null,
          inPlay: false,
          jersey: null,
          flag: null,
        },
        {
          no: 4,
          teamName: 'Test Team B4',
          leagueName: 'Test Competition',
          playedMatches: 3,
          wins: 0,
          draws: 1,
          losses: 2,
          points: 1,
          form: ['L', 'D', 'L'],
          qualification: null,
          color: null,
          inPlay: false,
          jersey: null,
          flag: 'https://widget.demo.suzumuchi.dk/icons/prematch/bd.svg',
        },
      ],
    },
  ],
  colorLegend: [{ color: 'green', label: 'Playoffs', description: 'Playoffs' }],
  totalTeams: null,
  totalGroups: 2,
  leagueName: 'Test Competition',
  knockout: null,
};

export default GROUP_TABLE_MOCK_DATA;
